import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import type { FulfillmentType } from '../../types/delivery';

interface FulfillmentSelectorProps {
  value: FulfillmentType;
  deliveryAvailable: boolean;
  /** When true, delivery card is disabled and shows "Coming soon". */
  deliveryComingSoon?: boolean;
  onChange: (value: FulfillmentType) => void;
}

const FulfillmentSelector: React.FC<FulfillmentSelectorProps> = ({
  value,
  deliveryAvailable,
  deliveryComingSoon = false,
  onChange,
}) => {
  const deliverySelectable = deliveryAvailable && !deliveryComingSoon;
  const deliverySubtext = deliveryComingSoon
    ? 'Coming soon'
    : deliveryAvailable
      ? 'Fee quoted at checkout'
      : 'Not available';

  return (
  <View style={styles.container}>
    <Text style={styles.title}>How would you like to receive your order?</Text>
    <View style={styles.row}>
      <TouchableOpacity
        style={[styles.card, value === 'pickup' && styles.cardSelected]}
        onPress={() => onChange('pickup')}
      >
        <Text style={styles.icon}>🏪</Text>
        <Text style={[styles.cardTitle, value === 'pickup' && styles.cardTitleSelected]}>
          Pickup
        </Text>
        <Text style={styles.cardSub}>Choose date & time</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[
          styles.card,
          value === 'delivery' && styles.cardSelected,
          !deliverySelectable && styles.cardDisabled,
        ]}
        onPress={() => deliverySelectable && onChange('delivery')}
        disabled={!deliverySelectable}
      >
        <Text style={styles.icon}>🚗</Text>
        <Text style={[styles.cardTitle, value === 'delivery' && styles.cardTitleSelected]}>
          Delivery
        </Text>
        <Text style={styles.cardSub}>{deliverySubtext}</Text>
      </TouchableOpacity>
    </View>
  </View>
  );
};

const styles = StyleSheet.create({
  container: { marginBottom: 16 },
  title: { fontSize: 16, fontWeight: '600', marginBottom: 12, color: '#1a1a1a' },
  row: { flexDirection: 'row', gap: 12 },
  card: {
    flex: 1,
    borderWidth: 2,
    borderColor: '#e1e5e9',
    borderRadius: 12,
    padding: 14,
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  cardSelected: { borderColor: '#007AFF', backgroundColor: '#f0f7ff' },
  cardDisabled: { opacity: 0.45 },
  icon: { fontSize: 28, marginBottom: 6 },
  cardTitle: { fontSize: 15, fontWeight: '700', color: '#333' },
  cardTitleSelected: { color: '#007AFF' },
  cardSub: { fontSize: 12, color: '#666', marginTop: 4, textAlign: 'center' },
});

export default FulfillmentSelector;
